import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

const FAQS = [
  {
    q: "Do I need prior trading experience to join?",
    a: "No. The course is structured from foundations up. We start with Market Profile basics, slowly layer Order Flow, and then combine the two. Many of our 500+ students started as complete beginners. All you need is curiosity and a willingness to be patient.",
  },
  {
    q: "Why can't I trade the shared levels in the first 2 months?",
    a: "Because pattern recognition needs reps before risk. For the first 2 months you observe how Market Profile levels react in real time, compare your reading with Vishnu sir's call-outs, and let the framework click. Trading too early breaks the learning loop and burns capital.",
  },
  {
    q: "What software / platform do I need?",
    a: "We use GoCharting for Market Profile + Order Flow. Pre-built templates are provided so you're plug-and-play from day one. You'll also need a broker (any reputable Indian broker works) and Zoom + WhatsApp + Telegram for community access.",
  },
  {
    q: "What does the live trading room cover?",
    a: "Daily 09:15 – 15:30 IST: opening auction read, intra-day MP levels, footprint reads as they happen, entry / exit zones for Nifty, Bank Nifty, Midcap, and select MCX commodities. Recordings are uploaded to Telegram so you never miss a session.",
  },
  {
    q: "How is the monthly 1-on-1 session structured?",
    a: "A 30–45 minute personal review. We go through your trade log, identify setup-compatibility gaps, refine sizing, and flag psychology patterns. It's the single highest-value piece of the program for most students.",
  },
  {
    q: "What's the refund or rollover policy?",
    a: "Seats are limited and content is delivered live, so we don't offer refunds once the cohort begins. If a personal emergency comes up before commencement (31 August 2026), we'll move you to the next batch. For specifics, reach out on WhatsApp.",
  },
  {
    q: "Is this SEBI-registered investment advice?",
    a: "No. Great Eagle Tech is an education and mentorship program. We teach methodology, not buy/sell calls. All trading decisions you make are your own responsibility.",
  },
  {
    q: "Can I retake the program?",
    a: "Yes. Alumni get access to the previous batch recordings as part of this enrollment, and discounted re-entry for the next live cohort if you want to attend live again.",
  },
];

export default function FAQ() {
  return (
    <section
      data-testid="faq-section"
      id="faq"
      className="py-20 lg:py-28 border-t border-[#D4D0C5]"
    >
      <div className="max-w-[1320px] mx-auto px-5 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#D9381E] mb-4">
              09 / FAQ
            </div>
            <h2 className="font-display font-black text-4xl lg:text-6xl tracking-tighter leading-[0.95]">
              Questions,
              <br />
              answered.
            </h2>
            <p className="font-body text-[#4A4A4A] mt-5 max-w-sm">
              Couldn't find what you're looking for? Ping <strong>EagleBot</strong> in
              the bottom right, or WhatsApp us directly.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion
              type="single"
              collapsible
              className="w-full border-t border-[#0A0A0A]"
              data-testid="faq-accordion"
            >
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-b border-[#0A0A0A]"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="hover:no-underline py-6 group [&[data-state=open]>span.plus]:hidden [&:not([data-state=open])>span.minus]:hidden">
                    <div className="flex items-center gap-5 text-left">
                      <span className="font-mono-acc text-xs text-[#D9381E]">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-display font-bold text-lg lg:text-xl tracking-tight">
                        {f.q}
                      </span>
                    </div>
                    <span className="plus font-mono-acc text-2xl font-light text-[#0A0A0A]">
                      +
                    </span>
                    <span className="minus font-mono-acc text-2xl font-light text-[#D9381E]">
                      −
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="font-body text-[#4A4A4A] text-base leading-relaxed pl-11 pb-6 pr-4">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
